import { useParams } from "react-router-dom";
import { CircularProgress } from '@mui/material';
import useFetch from "../useFetch";
import { useState } from "react";

const FrenchBksRead = () => {
    const {id} = useParams();
    const regex = /\*\*/g;
    const [nightMode,setNightmode] = useState(false);
    
    const {data: books, ispending,erroralert} = useFetch(`${process.env.REACT_APP_BOOKS_SERVER_URL}/FrenchBooks/`+ id);

    return ( 
        <div className={`blog-details ${nightMode? 'nightmode':'normal'}`}>
        {erroralert && <div> {erroralert}</div>}
      {ispending && <div style={{marginTop: "3rem"}}> 
      <CircularProgress color="secondary"/> <br/>
      Preparing Book...
      </div>} 

      {!ispending && !nightMode && <button id="toggleButton" onClick={() => {setNightmode(!nightMode)}}>Mode nuit</button>}
  {nightMode && <button id="toggleButton" onClick={() => {setNightmode(!nightMode)}} style={{
      backgroundColor: "#ddd",
      color: "black"
  }}>passer à la normale</button>}
  
    
      {books && (
           <article>
            <h2>{books.title}</h2>
            <h3>Écrit par le {books.author}</h3>
            <img src={books.image} alt="book cover"></img>
            <p>{books.body.replace(regex,"\n\n")}</p>
      
          </article>
      )}
  </div>
     );
}
 
export default FrenchBksRead;